import { ImResponse, resolve, doorClient } from '.';

export interface ListParams {
  page: number;
  pageSize: number;
}

export interface ListResponse {
  page: number;
  pageSize: number;
  total: number;
  extInfo: Assistant.GroupWithEnableInfo[];
}

export function list(params: ListParams) {
  return resolve(
    doorClient.get<ImResponse<ListResponse>>('/overseaim-store-home/v1/assistant-group/page-list', {
      params,
    }),
  );
}

export function allList() {
  return resolve(
    doorClient.get<ImResponse<Assistant.Group[] | undefined>>(
      '/overseaim-store-home/v1/assistant-group/org-list',
    ),
  );
}

export interface CreateBody extends Omit<Assistant.Group, 'id' | 'orgId' | 'stores' | 'users'> {
  storeIds: number[];
  userIds: number[];
  tunnelAccountIds: number[];
}

export function create(body: CreateBody) {
  return resolve(
    doorClient.post<ImResponse<string>>('/overseaim-store-home/v1/assistant-group', body),
  );
}

export interface UpdateBody extends CreateBody, Pick<Assistant.Group, 'id'> {}

export function update(body: UpdateBody) {
  return resolve(doorClient.put('/overseaim-store-home/v1/assistant-group', body));
}

export function del(id: Assistant.Group['id']) {
  return resolve(doorClient.delete(`/overseaim-store-home/v1/assistant-group?id=${id}`));
}

export function accountList() {
  return resolve(
    doorClient.get<ImResponse<Assistant.GroupAvailableAccount[] | undefined>>(
      '/overseaim-store-home/v1/assistant/list/has-distributed-permit',
    ),
  );
}

export function storeList() {
  return resolve(
    doorClient.get<ImResponse<Assistant.GroupAvailableStore[] | undefined>>(
      '/overseaim-store-home/v1/assistant-group/store-assistant-group',
    ),
  );
}

export function undistributedStoreList() {
  return resolve(
    doorClient.get<
      ImResponse<Pick<Assistant.GroupAvailableStore, 'storeId' | 'storeName'>[] | undefined>
    >('/overseaim-store-home/v1/assistant-group/undistributed-stores'),
  );
}
